// import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navigation from '../components/Navigation';
// import Loader from '../components/Loader'; 
import Footer from '../components/Footer';
import { footerEn } from '../data/footer';
import { navigationTop, navigationButtom } from '../params';
import { Link } from 'react-router-dom';

// import '../assets/scss/CoreLabsAboutUs.scss';
// import '../assets/scss/Articles.scss';
// import 'bootstrap/dist/css/bootstrap.min.css'; 




const navigationIntern = []

const crumb = [
  // { link: '//', text: 'Home' },
  { link: '//', text: 'Home' },

  { link: '/research/research-training', text: 'Research Training' },
    { link: '/research/citi', text: 'CITI' },
  { link: '/research/citi/rcr', text: 'RCR Basic Course Modules (Core Training)' },









]



function Rcr(props) {
  document.title = 'RCR Basic Course Modules (Core Training)'
  const poster = '/uploads/core-labs.png'
  //const src = '/uploads/welcome.mp4'
  const headerData = {
    title: 'RCR Basic Course Modules (Core Training)',
    crumb: crumb,
    navigationButtom: navigationButtom,
    navigationTop: navigationTop,
    applicationLinks: [{ text: 'Apply now', class: 'bordred', link: '/header/applynow' }],
  }


  
  return (
    <>
      <Navigation
        navigationIntern={navigationIntern}
        {...headerData}
        updateLang={props.updateLang}
      />
      <section className="space-block-60">
        <div className='container'>
            <div className='row-listing'>
      <p>Modules may be completed individually; however, successful completion
of all modules listed below is required to receive a CITI RCR Certificate of
Completion.</p>



            <div className="filter-container">
                <table className="views-table full-width table-style-2" style={{backgroundColor: '#ffffff'}}>
           
                    <thead>
                        <tr>
                            <th className="count-field"> # </th>
                            <th className="f-project-title">Course Title</th>
                            <th className="f-project-lead">Focus / Relevance </th>
                            <th className="f-project-entity">Suggested Integration at HBKU</th>
                            <th className="f-project-entity">Duration </th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr className="even">
                        <td className="text-center">1</td>
                        <td>Introduction to RCR</td>
                        <td>Core principles of responsible research practice</td>
                        <td>All researchers (onboarding & active research)</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">2</td>
                        <td>Authorship</td>
                        <td>Ethical authorship, publication practices, and acknowledgments</td>
                        <td>Researchers involved in scholarly publications</td>
                        <td>50-75 min</td>
                    </tr>
                    <tr className="even">
                        <td className="text-center">3</td>
                        <td>Collaborative Research</td>
                        <td>Ethical and regulatory issues in collaborative research</td>
                        <td>Interdisciplinary & externally sponsored research</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">4</td>
                        <td>Conflicts of Interest & Commitment</td>
                        <td>Financial and non-financial conflicts and objectivity</td>
                        <td>All researchers</td>
                        <td>50-75 min</td>
                    </tr>
                     <tr className="even">
                        <td className="text-center">5</td>
                        <td>Data Management</td>
                        <td>Data integrity, storage, sharing, and retention</td>
                        <td>All researchers</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">6</td>
                        <td>Financial Responsibility</td>
                        <td>Ethical financial stewardship in sponsored research</td>
                        <td>Funded research projects</td>
                        <td>50-75 min</td>
                    </tr>
                     <tr className="even">
                        <td className="text-center">7</td>
                        <td>Mentoring & Healthy Research Environments</td>
                        <td>Ethical mentoring and respectful research culture</td>
                        <td>Faculty & supervisors</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">8</td>
                        <td>Peer Review</td>
                        <td>Ethical responsibilities and confidentiality in peer review</td>
                        <td>Researchers serving as reviewers</td>
                        <td>50-75 min</td>
                    </tr>
                     <tr className="even">
                        <td className="text-center">9</td>
                        <td>Research Misconduct</td>
                        <td>Fabrication, falsification, plagiarism, and reporting processes</td>
                        <td>All researchers</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">10</td>
                        <td>Plagiarism</td>
                        <td>Proper citation and avoidance of plagiarism</td>
                        <td>All researchers</td>
                        <td>50-75 min</td>
                    </tr>
                     <tr className="even">
                        <td className="text-center">11</td>
                        <td>Research, Ethics, and Society</td>
                        <td>Societal and ethical impacts of research</td>
                        <td>All researchers</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">12</td>
                        <td>Research Involving Human Subjects</td>
                        <td>Ethical principles, informed consent, and IRB roles</td>
                        <td>Human subjects research</td>
                        <td>50-75 min</td>
                    </tr>
                     <tr className="even">
                        <td className="text-center">13</td>
                        <td>Using Animal Subjects in Research</td>
                        <td>Ethical and regulatory requirements for animal research</td>
                        <td>Animal research projects</td>
                        <td>50-75 min</td>
                        
                    </tr>
                    <tr className="odd">
                        <td className="text-center">14</td>
                        <td>Environmental & Social Dimensions of Engineering Research</td>
                        <td>Ethical and social responsibilities in engineering</td>
                        <td>Engineering research</td>
                        <td>50-75 min</td>
                    </tr>

                    
                    
                    </tbody>
                </table>
            </div>
            <h4>RCR Supplemental Modules</h4>
                        <div className="filter-container">
                <table className="views-table full-width table-style-2" style={{backgroundColor: '#ffffff'}}>
           
                    <thead>
                        <tr>
                        
                            <th className="f-project-title">Course Title</th>
                            <th className="f-project-lead">Focus / Relevance </th>
                            <th className="f-project-entity">Recommended For</th>
                            <th className="f-project-entity">Duration </th>
                           
                        </tr>
                    </thead>
                    <tbody>
                    <tr className="even">
                        <td >Reproducibility of Research Results</td>
                        <td>Causes and solutions to reproducibility challenges in research</td>
                        <td>Funded, empirical, and data-driven research</td>
                        <td>50–75 min</td>
                        
                        
                    </tr>
                    <tr className="odd">
                        <td >Communicating with the Public</td>
                        <td>Ethical communication of research findings to the public</td>
                        <td>Public-facing research and outreach</td>
                        <td>50–75 min</td>
                        
                    </tr>
                    <tr className="even">
                        
                        <td>Presentation of Research Findings</td>
                        <td>Accurate and ethical presentation of research data and images</td>
                        <td>Conferences, workshops, public presentations</td>
                        <td>50–75 min</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            </div>

          {/* <div className="d-flex justify-content-center">
              <Loader />
          </div> */}
        </div>
      </section>
      <Footer {...footerEn} />
    </>
  )
}

export default Rcr;
